import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '../../shared/static/common-functions';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventorySuppliersBus } from '@app/cp/shared/models/InventorySuppliersBus';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { ScheduleInvoiceBus } from '@app/cp/shared/models/ScheduleInvoiceBus';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { GItem } from '@app/cp/shared/models/GItem';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'schedule-invoices',
    templateUrl: './schedule-invoices.component.html',
    styleUrls: ['./schedule-invoices.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ScheduleInvoicesComponent extends BaseGridEditLineComponent<ScheduleInvoiceBus, null, InvoiceService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any; //Move this inside class

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InvoiceService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "ScheduleInvoiceBus";
        this.saveMode = SaveMode.all;
        this.appCode = "Scheduled-Invoices";
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'scheduleInvoiceId': new UntypedFormControl(),
            'companyId': new UntypedFormControl(),
            'invoiceId': new UntypedFormControl(),
            'unschedule': new UntypedFormControl(),
            'scheduleName': new UntypedFormControl(),
            'startDate': new UntypedFormControl(),
            'scheduleFrequencyId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'customerName': new UntypedFormControl(),
            'locationName': new UntypedFormControl(),
            'invoiceNumber': new UntypedFormControl(),
            'everyXMonths': new UntypedFormControl(),
            'isUpdated': new UntypedFormControl(),
            'isAdded': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            scheduleInvoiceId: this.selectedData.scheduleInvoiceId,
            companyId: this.selectedData.companyId,
            invoiceId: this.selectedData.invoiceId,
            unschedule: this.selectedData.unschedule,
            scheduleName: this.selectedData.scheduleName,
            startDate: this.selectedData.startDate,
            scheduleFrequencyId: this.selectedData.scheduleFrequencyId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            customerName: this.selectedData.customerName,
            locationName: this.selectedData.locationName,
            invoiceNumber: this.selectedData.invoiceNumber,
            everyXMonths: this.selectedData.everyXMonths,
            isUpdated: this.selectedData.isUpdated,
            isAdded: this.selectedData.isAdded
        });
    }
    customCellClick(col: ColumnComponent) {
            if (col.field === 'invoiceNumber') {
                this.invoiceSearch = true;
            }
    }
    public addHandler(): void {
        super.addHandler();
        this.doInvoiceSearch();
    }

    invoiceSearch: boolean = false;
    doInvoiceSearch() {
        this.ctrlOpenFlag = true;
        this.invoiceSearch = true;
    }
    invoiceSelected(value: any) {
        this.invoiceSearch = false;
        if (value != null) {
            //this.editForm.controls["dispatchNumber"].setValue(value.DispatchNumber);
            this.editForm.patchValue({
                invoiceNumber: value.InvoiceNumber,
                invoiceId: value.InvoiceId,
                customerName: value.CustomerName,
                locationName: value.LocationName
            });
            this.closeCtrlOpenFlag = true;
            this.showCpSearchDialog = false;
            this.ctrlOpenFlag = false;
            this.editForm.markAsDirty();
        }
    }
    subs_dataScheduledInvoices: Subscription;
    public setup(data: string) {
        this.clear();
        CommonFunctions.unsubscribe(this.subs_dataScheduledInvoices);
        this.subs_dataScheduledInvoices = this.svc_data.getScheduledInvoices().subscribe((data: ScheduleInvoiceBus[]) => {
            if (data != null && data.length > 0) {
                this.gridData = this.getGridData(data);
                this.cloneData();
                this.allOriginalData = _.cloneDeep(this.gridData);
            }
            else {
                this.gridData = null;
            }
        });
    }
    allOriginalData: ScheduleInvoiceBus[];

    test() {
        let rr = this.referenceData.getScheduleFrequencyName("253498d7-c704-45b0-9ad2-4bcedaf6fdba");
        //for (let i = 0; i < this.gridData.length; i++) {
        //    let frequency = this.referenceData.getScheduleFrequencyName(this.gridData[i].scheduleFrequencyId);
        //}
    }
    cancelEvent() {
        this.cancelHandler();
        this.gridData = null;
        this.close(false);
    }
    getChangedObject(data: ScheduleInvoiceBus) {
        let busObj: ScheduleInvoiceBus = new ScheduleInvoiceBus(data);
        busObj.setBeforeSave();
        return busObj;

    }
    saveEvent() {
        let dataObjs: ScheduleInvoiceBus[] = this.getChanged();
        let deletedObjs: GItem[] = this.getDeletedItems();
        for (let i = 0; i < deletedObjs.length; i++) {
            let dataObj = this.allOriginalData.find(s => s.CID() === deletedObjs[i].value);
            let busObj = this.getChangedObject(dataObj);
            busObj.unschedule = true;
            busObj.isUpdated = true;
            busObj.setBeforeSave();
            dataObjs.push(busObj);
        }
        this.svc_data.saveScheduledInvoices(dataObjs).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {

                this.saveSuccess(null);
                this.close(true);
            }
            else {
                this.saveError(null, info.message);
            }
        });
    }
    dataChanged: boolean = false;
    sendParentMessage(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        if (type === MessageType.changed) {
            this.dataChanged = true;
        }
        super.sendParentMessage(type, subject, message, values, value)
    }
    close(e: any) {
        this.dataChanged = false;
        super.close(e);
    }

}
